<template>
  <div class="header-wrap hidden">
    <section :class="[{'header-stateIf':state == true}]" class="header">
      <article class="header-img">
        <!--<i class="iconfont iconqiu" />智慧物流-->
        <img src="../../assets/img/logo.png" alt="">
      </article>
      <article class="header-con">
        <router-link
          v-for="(item,navIndex) in navData"
          :key="navIndex"
          :to="{name:item.name}"
          tag="div"
          class="nav-link"
        >
          <span class="nav-link-title">{{ item.title }}</span>
        </router-link>
      </article>
      <article :class="{'header-state':true, 'header-company': !isEmpty(companyInfo.companyName)}">
        <div class="left">
          <div class="select">
            <div class="select-box" :v-if="userInfo.authStatus == '2'">
              <span class="el-dropdown-link" @click="publish">
                <div class="header-state-icon">
                  <i class="iconfont iconfabu1" />
                </div>{{ userType.title }}
                <!--<i v-if="!roles.length" class="el-icon-arrow-down el-icon&#45;&#45;right" />-->
              </span>
            </div>

            <!--<el-dropdown trigger="click" @command="publish">-->
            <!--<span class="el-dropdown-link" @click="publish">-->
            <!--<div class="header-state-icon">-->
            <!--<i class="iconfont iconfabu1" />-->
            <!--</div>{{ userType.title }}-->
            <!--<i v-if="!roles.length" class="el-icon-arrow-down el-icon&#45;&#45;right" />-->
            <!--</span>-->
            <!--<el-dropdown-menu v-show="false" slot="dropdown" :class="{isShow: isShow}">-->
            <!--&lt;!&ndash;<el-dropdown-item command="0">运力发布</el-dropdown-item>&ndash;&gt;-->
            <!--&lt;!&ndash;<el-dropdown-item command="0">货源发布</el-dropdown-item>&ndash;&gt;-->
            <!--&lt;!&ndash;<el-dropdown-item command="0">仓储发布</el-dropdown-item>&ndash;&gt;-->
            <!--&lt;!&ndash;<el-dropdown-item command="0">需求发布</el-dropdown-item>&ndash;&gt;-->
            <!--</el-dropdown-menu>-->
            <!--</el-dropdown>-->
          </div>
        </div>
        <div class="right">
          <div v-if="roles.length" class="select user">
            <el-dropdown trigger="click" @command="userCommand">
              <span class="el-dropdown-link">
                <div class="header-state-icon">
                  <i class="iconfont iconfabu1" />
                </div>
                <div :class="{'user-info': !isEmpty(companyInfo.companyName)}" :title="companyInfo.companyName">
                  {{ name }}<br>
                  {{ companyInfo.companyName }}
                </div>
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="个人中心">个人中心</el-dropdown-item>
                <el-dropdown-item command="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-else class="login-wrap">
            <router-link tag="div" :to="{name: 'Login'}" class="login">登录</router-link>
            <router-link tag="div" :to="{name: 'Reg'}" class="register">注册</router-link>
          </div>
        </div>

      </article>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    state: { type: Boolean, default: false }
  },
  data() {
    return {
      navData: [
        { title: '首页', name: 'Home' },
        { title: '石化运输', name: 'PetroTransport' },
        { title: '石化云仓', name: 'Cloud' },
        { title: '物流监控', name: 'Monitor' },
        { title: '企业展示', name: 'EnterpriseShow' }
      ]
    }
  },
  computed: {
    ...mapGetters(['roles', 'name', 'token', 'userInfo', 'companyInfo']),
    isShow() {
      console.log(91, this.token === 'undefined')
      return this.token === 'string'
    },
    userType() {
      let title = '发布信息'
      let name = 'Login'
      switch (this.userInfo.userType) {
        case '1':
          title = '货源发布'
          name = 'PublishGoods'
          break
        case '2':
          title = '运力发布'
          name = 'PublishTransport'
          break
        case '3':
          title = '仓储发布'
          name = 'PublishSupply'
          break
        case '4':
          title = '需求发布'
          name = 'PublishDemand'
          break
        default:
          break
      }
      return {
        title,
        name
      }
    }
  },
  created() {
    console.log(this.userInfo)
  },
  methods: {
    userCommand(command) {
      if (command === '个人中心') {
        this.$router.push({ name: 'NewsNotice' })
      } else if (command === 'logout') {
        this.logout()
      }
    },
    // 退出登录
    async logout() {
      this.$router.push(`/`)
      setTimeout(() => {
        this.$store.dispatch('user/logout').then(res => {
        })
      }, 500)
    },
    publish(command) {
      if (this.userType.title == '发布信息') {
        this.$message({
          type: 'warning',
          message: '请先登录！'
        })
      }
      this.$router.push({ name: this.userType.name })
    },
    // 判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    }
  },
  watch:{
    $route(to,form){
    if(to.name=="Home"){
      this.$router.go(0)  
    }
      console.log(to)
  //
      }
  }
}
</script>
<style scoped lang='scss'>
.isShow{
  opacity: 0;
}


@media print {
  .hidden{
      display: none;
  }
}
.header-wrap {
  position: fixed;
  width: 100%;
  /**  message z-inde: 2004, loading z-index: 2000*/
  z-index: 2001;
}
.header {
  width: 100%;
  min-width: 1200px;
  height: 66px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 0px 1px #cfd4d5;
  &.header-stateIf {
    background: rgba(0, 0, 0, 0.6);
  }
}
.header-img {
  float: left;
  width: 30%;
  /*width: 200px;*/
  height: 66px;
  line-height: 66px;
  font-size: 24px;
  color: #fff;
  img{
    width: 150px;
    margin-left: 56px;
    margin-top: 6px;
  }
  i {
    font-size: 30px;
    vertical-align: middle;
    margin-right: 10px;
    margin-left: 60px;
    color: #f64c03;
  }
}
.header-con {
  width: 50%;
  float: left;
  box-sizing: border-box;
  padding-left: 20px;
  .nav-link {
    height: 66px;
    line-height: 66px;
    float: left;
    font-size: 16px;
    margin: 0 40px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .nav-link-title {
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }
    &.active .nav-link-title {
      font-weight: bold;
      color: #bf291b;
    }
    &.active {
      border-bottom: 2px solid #bf291b;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.header-state {
  width: 20%;
  height: 66px;
  float: right;
  display: flex;
  justify-content: space-between;
  .user{
    margin-right: 60px;
  }
  .select {
    cursor: pointer;
    .select-box{
      width: 100px;
      line-height: 66px;
      .el-dropdown-link{
        color: #fff;
        font-size: 14px;
      }
    }
    .header-state-icon {
      display: inline-block;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: #bf2316;
      line-height: 18px;
      text-align: center;
      margin-right: 7px;
      i {
        color: #fff;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin-left: 2px;
      }
    }
    .el-dropdown {
      height: 66px;
      line-height: 66px;
      .el-dropdown-link {
        color: #fff;
        // font-weight: bold;
        font-size: 14px;
        white-space: nowrap;
        text-overflow: clip;

        // 企业信息
        display: flex;
        flex-direction: row;
        height: 100%;
        align-items: center;
        padding: 0 5px;
        text-align: center;
        .user-info{
          line-height: 17px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 80%;
        }
      }
    }
  }
  .login-wrap {
    position: relative;
    float: right;
    width: 94px;
    height: 32px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    margin-top: 18px;
    margin-right: 60px;
    &:before {
      position: absolute;
      content: "";
      width: 1px;
      height: 50%;
      top: 25%;
      left: 50%;
      background: #be2316;
    }
    .login,
    .register {
      width: 50%;
      float: left;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
      color: #be2316;
    }
  }
}
@media screen and (max-width: 1400px) {
  /*当屏幕尺寸小于1400px时，应用下面的CSS样式*/
  .header-img {
    width: 26%;
  }
  .header-state {
    width: 20%;
     .select .el-dropdown .el-dropdown-link .user-info{
      line-height: 17px;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 63%;
    }
  }
  .header-company{
    width: 24%;
  }
  .header-con {
    width: 50%;
    padding-left: 30px;
    .nav-link {
      margin: 0 28px !important;
    }
  }
  .login-wrap {
    margin-right: 40px !important;
  }


}

</style>
